<app-modal [dismissible]="false" class="task-photo-upload-modal">
    <div class="modal-header" modal-header>
        <h5 class="modal-title">{{
                (readonly ? 'admin.toolMaintenancePlans.tasks.createModal.photoModal.readonlyTitle'
                    : 'admin.toolMaintenancePlans.tasks.createModal.photoModal.title') | translate
            }}</h5>
    </div>
    <div class="modal-body" modal-body>
        <h6 *ngIf="!readonly">
            {{ 'admin.toolMaintenancePlans.tasks.createModal.photoModal.dragNDrop' | translate }}
        </h6>
        <app-photo-input [carouselPhotos]="photos"
                         [readonly]="readonly"
                         (changeFiles)="onFilesChanged($event)">
        </app-photo-input>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="simple"
                    (click)="onCancel()"
                    [disabled]="isConfirmationInProgress"
                    data-dismiss="modal">{{ "generic.buttons.close" | translate }}
        </app-button>
        <app-button *ngIf="!readonly"
                    type="primary"
                    class="btn btn-primary"
                    (click)="onConfirm()"
                    data-dismiss="modal">{{ "generic.buttons.confirm" | translate }}
        </app-button>
    </div>
</app-modal>
